var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"estaciones"},[_c('map-overlay',{attrs:{"type":"estaciones"}}),_c('footer',{staticClass:"estaciones__bar"},[_c('desktop-footer',{staticClass:"estaciones__bar__desktop-footer"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }